import styled from 'styled-components';
import SmallInput from '../../../components/utils/inputs/SmallInput/SmallInput';
import { Button } from '../../../components/utils/Button/Button';

export const PageContainer = styled.div`
  padding: 2.4rem 1.6rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 2.4rem;
  flex-grow: 1;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const TitleRightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const Input = styled(SmallInput)`
  min-width: 19rem;
  input {
    height: 3.4rem;
  }
`;

export const StyleButton = styled(Button)`
  height: 3.4rem;
  border-radius: 8px;
  border: 1px solid #61ade9;
  background: linear-gradient(93deg, var(--Blue-500, #3e9be4) 6.75%, var(--Blue-700, #1672ba) 93.25%);
  font-size: 1.4rem;
  font-weight: 400;
  letter-spacing: -0.42px;
  padding: 0 3.2rem;
`;
